import { type FC } from "react";
import { Link } from "@root/shared/components/Link";
import { Icon } from "@root/shared/components/Icon";
import { Employments } from "@clientFrontend/utils/constants";
import { WorkRequirementItem } from "./uiParts/WorkRequirementItem";
import type { WorkRequirement } from "./type";
import * as styles from "./styles.css";

type Props = {
  editUrl: string;
  canEdit: boolean;
  workRequirements: WorkRequirement[];
  site: "biyo" | "kaigo";
};

export const WorkRequirementList: FC<Props> = ({ editUrl, canEdit, workRequirements, site }) => {
  return (
    <>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle[site]}>雇用形態</h2>
        {Employments.map((employment) => (
          <WorkRequirementItem
            key={employment.no}
            employment={employment}
            workRequirement={workRequirements.find(
              (workRequirement) => workRequirement.employmentNumber === employment.no,
            )}
            site={site}
          />
        ))}
      </section>
      <div className={styles.editButtonContainer}>
        <Link href={editUrl} theme={canEdit ? "primary" : "disabled"} className={styles.editButton}>
          <Icon name="edit" />
          編集する
        </Link>
      </div>
    </>
  );
};
